import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPolicyMapDetail } from '@shared/models/scim-admin';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-policy-map-detail-dialog',
	standalone: false,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './policy-map-detail-dialog.component.html',
})
export class PolicyMapDetailDialogComponent implements OnDestroy {
	private destroy$ = new Subject<void>();

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IPolicyMapDetail,
		public dialogRef: MatDialogRef<PolicyMapDetailDialogComponent>,
	) {}

	onClose(): void {
		this.dialogRef.close();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
